const validateFetch = async (response) => {
    let errMessage;
    if (!response.ok) {
        let errData;
        await response
            .json()
            .then(json => {
            errData = json; // api return a message
        })
            .catch(e => {
            errData = response.statusText; //api did not return a message
        });
        errMessage =
            errData && errData.errors
                ? errData.errors[0].message
                : response.statusText;
        throw Error(errMessage);
    }
    return response;
};
export default function getCreativePromise(creativeID, api) {
    const dataApiCb = true;
    const cb = dataApiCb ? `?cb=${Date.now().toString()}` : '';
    return fetch(`${api}${creativeID}/player${cb}`)
        .then(validateFetch)
        .then(response => response.json())
        .then((response) => {
        return response.data;
    });
}
